// Pure mapper from a better-auth / WebAuthn passkey error to a UI bucket.
// Shared by /login, the Security settings section and the enrollment nudge.
// Buckets : 'cancelled' | 'alreadyRegistered' | 'notFound' | 'sessionNotFresh' | 'generic'.

const CANCELLED = new Set([
  'ERROR_CEREMONY_ABORTED',
  'AUTH_CANCELLED',
  'NotAllowedError',
  'AbortError',
]);
const NOT_FOUND = new Set(['PASSKEY_NOT_FOUND', 'AUTHENTICATION_FAILED']);

export function classifyPasskeyError(error) {
  if (!error) return 'generic';
  const code = error.code ?? error.name ?? error.message;
  if (CANCELLED.has(code)) return 'cancelled';
  // better-auth freshSessionMiddleware : 403 SESSION_NOT_FRESH when the session
  // is older than session.freshAge (default 24 h).
  if (code === 'SESSION_NOT_FRESH') return 'sessionNotFresh';
  if (code === 'ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED') return 'alreadyRegistered';
  if (NOT_FOUND.has(code)) return 'notFound';
  return 'generic';
}

export const PASSKEY_NAME_MAX = 64;

export async function signOutToLogin() {
  try {
    const { authClient } = await import('./client.js');
    await authClient.signOut();
  } catch {
    // swallowed on purpose : the navigation below is the recovery path
  } finally {
    // Hard navigation : clears every in-memory cache (react-query, sockets).
    // Runs even if signOut failed — /login is where the user can recover.
    window.location.assign('/login');
  }
}

export function passkeysSupported() {
  return typeof window !== 'undefined' && Boolean(window.PublicKeyCredential);
}
